import { CourseViewStore } from '../typings';

export const courseViewSelector = <T extends { courseView: CourseViewStore }>(storeState: T) => storeState.courseView;
